import { render, staticRenderFns } from "./Advanced.vue?vue&type=template&id=13ab4706&scoped=true&"
import script from "./Advanced.vue?vue&type=script&lang=js&"
export * from "./Advanced.vue?vue&type=script&lang=js&"
import style0 from "./Advanced.vue?vue&type=style&index=0&id=13ab4706&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ab4706",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ab4706')) {
      api.createRecord('13ab4706', component.options)
    } else {
      api.reload('13ab4706', component.options)
    }
    module.hot.accept("./Advanced.vue?vue&type=template&id=13ab4706&scoped=true&", function () {
      api.rerender('13ab4706', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examples/profile/advanced/Advanced.vue"
export default component.exports